import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { LazyLoadFallback } from '../page-common/LazyLoadFallback';
import { I18nProvider } from '@atlassian/embedded-confluence-common';
import fetchTranslations from '../i18n/fetchTranslations';
const LazyViewPage = lazyForPaint(() => import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-view-page" */
'./ViewPage'));
// Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
// They will not function correctly due to a lack of I18n context.

export const ViewPage = props => /*#__PURE__*/React.createElement(I18nProvider, {
  locale: props.locale,
  fetchTranslations: fetchTranslations
}, /*#__PURE__*/React.createElement(LazySuspense, {
  fallback: /*#__PURE__*/React.createElement(LazyLoadFallback, null)
}, /*#__PURE__*/React.createElement(LazyViewPage, props)));